import React from 'react'
import { Link } from 'gatsby'
import { css, useTheme } from '@emotion/react'
import arrowRightPrimary from '../images/svgs/arrow-right-primary.svg'

const articleItemStyle = theme => css({
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'space-between', 
    padding: 16, 
    border: `1px solid ${theme.colors.mutedDark}`, 
    '&:hover': { 
        color: 'white' 
    } 
})

const articleCtaStyle = theme => css({
    border: 'none',
    background: 'transparent',
    color: 'white',
    display: 'flex',
    gap: 4,
    alignItems: 'center',
    padding: 0,
    textTransform: 'uppercase',
    color: theme.colors.primary,
    fontWeight: 700,
    marginTop: 24,
    fontSize: 12,
    fontFamily: theme.fonts.secondary,
    '&:hover': {
        cursor: 'pointer',
    }
})

export default function ArticleCard({ article }){
    const { data } = article || {}
    const theme = useTheme()
    return(
        <Link className='product-card' to={data?.url} css={articleItemStyle}>
            <div>
                <img src={data?.thumbnail} alt='' css={{ width: '100%', }} />
                <h3 css={{ fontFamily: theme.fonts.secondary, fontWeight: 400, fontSize: 16, marginTop: 24, color: 'white', }}>
                    {data?.title}
                </h3>
                <p css={{ textTransform: 'uppercase', fontWeight: 700, color: theme.colors.mutedLight, marginTop: 12, marginBottom: 12, }}>
                    {data?.categories?.lvl0}
                </p>
                <p css={{ color: theme.colors.mutedLight, margin: 0, }}>
                    {data?.description}
                </p>
                <ul css={{ listStyleType: 'none', paddingLeft: 0, marginTop: 24, marginBottom: 0, }}>
                    {data?.categories?.lvl1.map((article, index) => {
                        const isLast = index === data?.categories?.lvl1?.length - 1
                        const subcategory = article?.split(' > ')[1]
                        return(
                            <li key={`${data?.url}-${article}-${index}`} css={{ color: 'white', display: 'inline-block' }}>
                                {subcategory}
                                {isLast ? '' : <span>,&nbsp;</span>}
                            </li>
                        )
                    })}
                </ul>
            </div>
            <button className='product-card-cta' css={articleCtaStyle}>
                {
                    data?.categories?.lvl1?.some(article => article.split(' > ')[1].toLowerCase().includes('video')) ?
                    'watch the video' : 
                    'read more'
                }
                <img src={arrowRightPrimary} alt='' />
            </button>
        </Link>
    )
}